import { z } from 'zod';

export const ModuleConfigSchema = z.object({
  enabled: z.boolean(),
  node_types: z.array(z.string()).optional(),
  edge_types: z.array(z.string()).optional(),
  settings: z.record(z.any()).optional(),
});

export const TenantModuleConfigSchema = z.record(ModuleConfigSchema);

export type ModuleConfig = z.infer<typeof ModuleConfigSchema>;
export type TenantModuleConfig = z.infer<typeof TenantModuleConfigSchema>;

/**
 * Generate default module config for a tenant with all modules enabled
 */
export function getDefaultModuleConfig(): TenantModuleConfig {
  return {
    'base-crm': {
      enabled: true,
      node_types: ['Person', 'Organization', 'Activity', 'Task', 'Document'],
      edge_types: ['WORKS_AT', 'REPORTS_TO', 'PARTICIPATED_IN', 'RELATED_TO'],
    },
    pmn: {
      enabled: true,
      node_types: ['Property', 'Metric', 'Narrative'],
      edge_types: ['HAS_PROPERTY', 'HAS_METRIC', 'HAS_NARRATIVE'],
    },
    sales: {
      enabled: true,
      node_types: ['Opportunity'],
      edge_types: ['OPPORTUNITY_FOR', 'CONTACT_FOR', 'RELATED_TO'],
    },
    marketing: {
      enabled: true,
      node_types: ['Campaign', 'Event'],
      edge_types: ['MEMBER_OF', 'REGISTERED_FOR', 'PART_OF', 'RELATED_TO'],
    },
    'pevc-dealflow': {
      enabled: true,
      node_types: ['Deal'],
      edge_types: ['DEAL_FOR', 'INVESTING_FROM', 'PARTICIPATED_IN', 'CONVERTED_TO', 'RELATED_TO'],
    },
    'pevc-portfolio': {
      enabled: true,
      node_types: ['Investment', 'ExternalFund'],
      edge_types: ['INVESTMENT_IN', 'INVESTMENT_FROM', 'ORIGINATED_FROM', 'MANAGED_BY', 'HAS_PORTFOLIO', 'RELATED_TO'],
    },
    'pevc-fundraising': {
      enabled: true,
      node_types: ['Vehicle', 'FundraisingOpportunity'],
      edge_types: ['OPPORTUNITY_FOR', 'PARTICIPATED_IN', 'RELATED_TO'],
    },
    'pevc-ir': {
      enabled: true,
      node_types: ['Subscription', 'InvestmentAccount', 'CapitalCall', 'Distribution', 'Report'],
      edge_types: ['SUBSCRIPTION_FROM', 'SUBSCRIPTION_TO', 'ACCOUNT_FOR', 'CONTACT_FOR', 'CALL_FOR', 'CALL_FROM', 'DISTRIBUTION_FOR', 'DISTRIBUTION_FROM', 'REPORT_FOR', 'SENT_TO', 'RELATED_TO'],
    },
  };
}
